module.exports = __webpack_public_path__ + "static/media/dot.6614cb27.svg";